import React, { useState, useEffect, useCallback } from 'react';

const About = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: require('../assets/novia1.webp'),
      alt: "Ramo de novia 1"
    },
    {
      id: 2,
      image: require('../assets/novia2.webp'),
      alt: "Ramo de novia 2"
    },
    {
      id: 3,
      image: require('../assets/novia3.webp'),
      alt: "Ramo de novia 3"
    },
    {
      id: 4,
      image: require('../assets/novia4.webp'),
      alt: "Ramo de novia 4"
    }
  ];

  const goToNext = useCallback(() => {
    setCurrentSlide((prevSlide) => 
      prevSlide === slides.length - 1 ? 0 : prevSlide + 1
    );
  }, [slides.length]);

  const goToPrevious = () => {
    setCurrentSlide((prevSlide) => 
      prevSlide === 0 ? slides.length - 1 : prevSlide - 1
    );
  };

  const handleClick = () => {
    goToNext();
  };

  const handleTouchStart = (e) => {
    const touchStartX = e.touches[0].clientX;
    e.target.dataset.touchStartX = touchStartX;
  };

  const handleTouchEnd = (e) => {
    const touchStartX = parseInt(e.target.dataset.touchStartX || '0');
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > 50) { // Mínimo swipe de 50px
      if (diff > 0) {
        goToNext(); // Swipe left -> siguiente
      } else {
        goToPrevious(); // Swipe right -> anterior
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 4000); // Cambia cada 4 segundos

    return () => clearInterval(interval);
  }, [goToNext]);

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="about-title">Bodas y Eventos</h2>
        <div className="about-container">
          <div className="about-content">
            <p className="about-question">
              ¿Quieres crear/diseñar algo especial con nosotros? 
            </p>
            <p className="about-question">
              Cuéntanos tu idea...
            </p>
            
            {/* Carrusel de fotos */}
            <div className="about-carousel">
              <div 
                className="about-carousel-container"
                onClick={handleClick}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                {slides.map((slide, index) => (
                  <div
                    key={slide.id}
                    className={`about-carousel-slide ${index === currentSlide ? 'active' : ''}`}
                  >
                    <img src={slide.image} alt={slide.alt} />
                  </div>
                ))}
              </div>
              
              {/* Indicadores */}
              <div className="about-carousel-dots">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
